exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".config[data-v-c97f0892]{position:relative}.slot-container[data-v-c97f0892]{width:calc(100% - 20px)}.controls[data-v-c97f0892]{position:absolute;top:0;right:0}.controls .af-icons-chevron-down[data-v-c97f0892]{transform:rotate(-90deg)}.controls.expanded .af-icons-chevron-down[data-v-c97f0892]{transform:rotate(90deg)}.fixed[data-v-c97f0892]{z-index:1000;position:fixed;max-width:90%}", ""]);

// exports
